import React, { useState, useEffect } from "react";
import "./Event.scss";
import { Button, Image, Modal } from "antd";
import { Link, useHistory, useNavigate } from "react-router-dom";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { getRequest, patchRequest } from "../../../api/http";
import placementOfficer from "../../../api/placementOfficer";
import collegeLogo from "../../../assets/images/college-logo.jpg";
import bannerLogo from "../../../assets/images/college-banner.svg";
import ErrorIcon from "../../../assets/images/icons/Pagenotfound.svg";
import { LoadingView } from "../../common";
import OngoingIcon from "../../../assets/images/icons/ongoing.png";
import UpcomingIcon from "../../../assets/images/icons/upcoming.png";
import ExpiredIcon from "../../../assets/images/icons/Expired.png";
import moment from "moment";
import toastr from "toastr";

function Event() {
  const [events, setEvents] = useState([]);
  const [showMenuIndex, setShowMenuIndex] = useState(null);
  const [editingEvent, setEditingEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteEventId, setDeleteEventId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEvents();
    localStorage.setItem("activeTabKey", "/pemployers");
  }, []);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await getRequest(placementOfficer.getAllEvents());
      setEvents(response);
    } catch (error) {
      console.error("Error fetching events:", error);
      toastr.error("Failed to fetch events. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const toggleMenu = (index, e) => {
    e.stopPropagation();
    setShowMenuIndex(index === showMenuIndex ? null : index);
  };

  const handleEditClick = (event, e) => {
    e.stopPropagation();
    navigate("/CreateEvent", { state: { event } });
  };

  const handleDeleteClick = (id, index, e) => {
    e.stopPropagation();
    setDeleteEventId(id);
    setIsModalVisible(true);
    toggleMenu(index, e);
  };

  const handleDeleteConfirmation = async () => {
    try {
      await patchRequest(placementOfficer.deleteEvent(deleteEventId), {});
      toastr.success("The event has been deleted successfully.");
      setLoading(true);
      fetchEvents();
    } catch (error) {
      console.error("Error deleting event:", error);
      toastr.error(error.message);
    } finally {
      setLoading(false);
      setDeleteEventId(null);
      setIsModalVisible(false);
    }
  };

  const handleCancelDelete = () => {
    setIsModalVisible(false);
    setDeleteEventId(null);
  };

  const formatDateTime = (dateTimeString) => {
  const localTime = moment(dateTimeString);
  return localTime.format("h:mm A, MMM D, YYYY");
};
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  if (loading) return <LoadingView />;

  return (
    <>
      <div className="event-container">
        <div className="header-events">
          <h3 className="heading">Events!</h3>
          <Link className="btn ant-btn ant-btn-primary" to="/CreateEvent">
            Create Event
          </Link>
        </div>
        <div className="event-list">
          {events?.length > 0 ? (
            events?.map((event, index) => {
              const startDateFormatted = formatDateTime(event?.startDate);
              const endDateFormatted = formatDateTime(event?.endDate);
              const truncatedName = truncateText(event?.name, 50);
              const truncatedVenue = truncateText(event?.venue, 25);
              return (
                <div className="event-card" key={index}>
                  <div
                    onClick={() =>
                      navigate(`/home/${event.id}`, {
                        state: { eventName: event?.name },
                      })
                    }
                    key={index}
                    style={{ cursor: "pointer" }}
                  >
                    <div>
                      <div className="banner-logo-section">
                        <div className="banner-logo-content">
                          <img
                            src={event?.bannerImageUrl || bannerLogo}
                            alt="Banner"
                            className="banner"
                          />
                          {event?.eventStatus === "ONGOING" ? (
                            <img src={OngoingIcon} alt="" className="tag" />
                          ) : event?.eventStatus === "UPCOMING" ? (
                            <img src={UpcomingIcon} alt="" className="tag" />
                          ) : (
                            <img src={ExpiredIcon} alt="" className="tag" />
                          )}
                          <div className="logo-container">
                            <img
                              src={event?.logoUrl || collegeLogo}
                              alt="Company Logo"
                              className="logo"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card-content">
                        <div className="details-event">
                          <div className="details-heading">
                            <div className="name">{truncatedName}</div>
                          </div>
                          <div className="date">
                            <div style={{ display: "flex" }}>
                              <div className="start-date">Starts from </div>
                              <div style={{ marginLeft: "5px" }}>
                                {" "}
                                {startDateFormatted}
                              </div>
                            </div>
                            <div style={{ display: "flex" }}>
                              <div className="end-date">Ends on </div>
                              <div style={{ marginLeft: "5px" }}>
                                {" "}
                                {endDateFormatted}
                              </div>
                            </div>
                          </div>
                          <div className="type ">{truncatedVenue}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu" onClick={(e) => toggleMenu(index, e)}>
                    ⋮
                    {showMenuIndex === index && (
                      <div className="menu-options">
                        <div onClick={(e) => handleEditClick(event, e)}>
                          <EditOutlined style={{ marginRight: 10 }} />
                          Edit
                        </div>
                        <div
                          onClick={(e) => handleDeleteClick(event.id, index, e)}
                        >
                          <DeleteOutlined style={{ marginRight: 10 }} />
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                width: "50%",
                margin: "auto",
              }}
            >
              <div className="errorMsg">
                <Image src={ErrorIcon} preview={false} />
                <h3>No Events!</h3>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Confirm Delete"
        visible={isModalVisible}
        onOk={handleDeleteConfirmation}
        onCancel={handleCancelDelete}
        okText="Delete"
        cancelText="Cancel"
      >
        <p>Are you sure you want to delete this event?</p>
      </Modal>
    </>
  );
}

export default Event;
